import _wellKnownSymbolDefine from "../internals/well-known-symbol-define";
var defineWellKnownSymbol = _wellKnownSymbolDefine;

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol("matchAll");
export default {};